export default "<div id=\"tab{{id}}\" class=\"tab-pane fade {{#if active}}in active{{/if}}\" role=\"tabpanel\" >\n    {{> @partial-block }}\n</div>";